import type { OpUnitType } from "dayjs";
import dayjs from "dayjs";

import type { RawDate } from "app/UtilitiesAndConstants/types/dates";

const getMonthDetails = (sysdate = dayjs().utc()) => {
    const monthName = sysdate.format("MMMM");
    const monthNumber = sysdate.format("M");
    return { monthNumber, monthName };
};

export const isEndOfPeriod = (date: RawDate, unit: OpUnitType): boolean => {
    const dateObject = dayjs(date);

    return dateObject.isSame(dateObject.endOf(unit), "day");
};

export const getDateAsText = (date: Date = new Date()): string => {
    return date.toISOString().split("T")[0];
};
